var FullHeight = {
	init:function(){
		$(window).resize(function(){
			FullHeight.resize();
		});
		FullHeight.resize();
	},
	resize:function(){
		var vh = $(window).innerHeight() * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');
	}
}